import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiService} from './api.service';
import {Router} from '@angular/router';
import {SessionService} from '../session.service';

@Injectable({providedIn: 'root'})
export class AuthService {
  constructor(
    private readonly apiService: ApiService,
    private readonly router: Router,
    private readonly sessionService: SessionService
  ) {
  }

  public signup(data: any): Observable<any> {
    return this.apiService.post(`/auth/signup`, data);
  }

  public login(data: any): Observable<any> {
    return this.apiService.post(`/auth/login`, data);
  }

  public resetPassword(data: { email: string }): Observable<any> {
    return this.apiService.post(`/auth/reset-password`, data);
  }

  public setNewPassword(data: any): Observable<any> {
    return this.apiService.post(`/auth/new-password`, data);
  }

  public logout(): void {
    this.sessionService.end();
    this.router.navigate(['/login']);
  }

  public activateInvitation(data: any): Observable<any> {
    return this.apiService.post(`/new-password`, data);
  }
}
